import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const StoreCtx = createContext(null);

export function StoreProvider({ children }) {
  const [products, setProducts] = useState([]);
  const [cities, setCities] = useState([]);
  const [settings, setSettings] = useState({});
  const [loaded, setLoaded] = useState(false);

  const load = useCallback(async () => {
    const [p, c, s] = await Promise.allSettled([api.get("/products"), api.get("/cities"), api.get("/settings/public")]);
    setProducts(Array.isArray(p.value?.data) ? p.value.data : []);
    setCities(Array.isArray(c.value?.data) ? c.value.data : []);
    setSettings(s.value?.data || {});
    setLoaded(true);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return <StoreCtx.Provider value={{ products, cities, settings, loaded, reload: load }}>{children}</StoreCtx.Provider>;
}

export const useStore = () => useContext(StoreCtx);
